import React, { ReactElement, memo } from 'react';
import {
  OfferDecline,
  OfferNew,
  OfferAccept,
  CrossIcon,
  ConversationIcon,
  OfferCounter,
  OfferReview,
} from '../icons/favoriteIcons';
import {
  ButtonContainer,
  OfferNewButton,
  OfferIconContainer,
  OfferDeclineButton,
  OfferDeclineIconContainer,
  OfferAcceptButton,
  OfferAccepIconContainer,
  DismissButton,
  DismissIconContainer,
  OfferCounterButton as MessageButton,
  OfferCounterIconContainer,
  OfferCancelButton,
  OfferCancelIconContainer,
  OfferMessageIconContainer,
} from './FavoriteButtonStyles';

interface IFavoriteOfferButton {
  type: string;
  label?: string;
  customLabelStyle?: React.CSSProperties;
  forceLabel?: string;
  contentText?: any;
  customButtonStyle?: React.CSSProperties;
  isFromOffer?: boolean;
  offer?: any;
  page?: any;
  viewType?: any;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const FavoriteOfferButton = (props: IFavoriteOfferButton): ReactElement => {
  const { label, customLabelStyle = {}, forceLabel, contentText = null, customButtonStyle = {}, ...rest } = props;
  const actionType = props.type ? props.type : 'offer';

  return (
    <div>
      {actionType === 'cancel' && (
        <ButtonContainer aria-label="Cancel">
          <OfferCancelButton
            className="favorite-offer-cancel-button"
            {...rest}
            type="button"
            aria-label="Cancel"
            title="Cancel your Date Offer"
            style={{ margin: props.isFromOffer ? '5px 0' : '5px 10px', position: 'relative' }}
          >
            <OfferCancelIconContainer>
              <CrossIcon fill="#E21D4A" />
            </OfferCancelIconContainer>
          </OfferCancelButton>
          <label>Cancel</label>
        </ButtonContainer>
      )}
      {actionType === 'decline' && (
        <ButtonContainer aria-label="Decline">
          <OfferDeclineButton
            className="favorite-offer-decline-button"
            {...rest}
            type="button"
            style={{ margin: '5px 15px', ...rest.style }}
            aria-label="Decline"
            title="Decline a Date Offer"
          >
            <OfferDeclineIconContainer>
              <OfferDecline />
            </OfferDeclineIconContainer>
          </OfferDeclineButton>
          <label style={customLabelStyle}>Decline</label>
        </ButtonContainer>
      )}
      {actionType === 'offer' && (
        <ButtonContainer aria-label="Offer" className="offerButtonContainer">
          <OfferNewButton
            className="favorite-offer-new-button"
            {...rest}
            type="button"
            aria-label="Offer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: props.isFromOffer ? '5px 0' : '5px 15px',
              ...customButtonStyle,
            }}
            title="Make a Date Offer"
          >
            <OfferIconContainer style={{ paddingTop: 5 }}>
              <OfferNew />{' '}
            </OfferIconContainer>
          </OfferNewButton>
          {forceLabel ? (
            <label style={customLabelStyle}>{forceLabel}</label>
          ) : (
            <label style={customLabelStyle}>{label ?? contentText ?? 'Make Offer'}</label>
          )}
        </ButtonContainer>
      )}
      {actionType === 'accept' && (
        <ButtonContainer aria-label="Accept">
          <OfferAcceptButton
            className="favorite-offer-review-button"
            data-test-id="favorite-offer-review-button"
            {...rest}
            type="button"
            aria-label="review"
            title="Review a Date Offer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: props.isFromOffer ? '5px 0' : '5px 15px',
              ...rest.style,
            }}
          >
            <OfferAccepIconContainer>{label ? <OfferAccept /> : <OfferReview />} </OfferAccepIconContainer>
          </OfferAcceptButton>
          <label style={customLabelStyle}>{label ?? 'Review'}</label>
        </ButtonContainer>
      )}
      {actionType === 'conversation' && (
        <ButtonContainer aria-label="Message">
          <MessageButton
            className="favorite-message-button"
            {...rest}
            type="button"
            aria-label="Message"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            title="Go to Messages"
          >
            <OfferMessageIconContainer>
              <ConversationIcon />{' '}
            </OfferMessageIconContainer>
          </MessageButton>
          <label>Message</label>
        </ButtonContainer>
      )}
      {actionType === 'dismiss' && (
        <ButtonContainer aria-label="Dismiss">
          <DismissButton
            className="favorite-dismiss-button"
            {...rest}
            type="button"
            aria-label="Dismiss"
            title="Dismiss profile"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <DismissIconContainer>
              <CrossIcon />{' '}
            </DismissIconContainer>
          </DismissButton>
          <label style={customLabelStyle}>Dismiss</label>
        </ButtonContainer>
      )}
      {actionType === 'counter' && (
        <ButtonContainer aria-label="Counter">
          <MessageButton
            className="favorite-counter-button"
            {...rest}
            type="button"
            aria-label="Counter"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '5px 15px',
              ...rest.style,
            }}
            title="Go to Counter"
          >
            <OfferCounterIconContainer>
              <OfferCounter />{' '}
            </OfferCounterIconContainer>
          </MessageButton>
          <label style={customLabelStyle}>Counter</label>
        </ButtonContainer>
      )}
    </div>
  );
};

FavoriteOfferButton.defaultProps = {
  hasOffer: false,
  label: null,
  isFromOffer: false,
};

export default memo(FavoriteOfferButton);
